import {UserActions, User} from '../constants/User'

const user = JSON.parse(localStorage.getItem(User.USER_OBJ_KEY))
const initialState = {userinfo: user, isLoggedIn: user ? true :  false}

function userReducer(state=initialState, action){
    switch(action.type){
        case UserActions.SET_USER_LOGIN:
            localStorage.setItem(User.USER_OBJ_KEY, JSON.stringify(action.payload))
            return {
                ...state,
                userinfo: action.payload,
                isLoggedIn: true
            }
        case UserActions.SET_USER_LOGOUT:
            localStorage.removeItem(User.USER_OBJ_KEY)
            return {
                ...state,
                userinfo: null,
                isLoggedIn: false
            }
        default:
            return state
    }
}
export default userReducer